import React from "react";

export default function footer() {
  return (
    <footer className="bg-[#043c94] text-center  lg:text-left">
      <div className="p-4 text-center text-neutral-700 dark:text-neutral-200">
        © 2024 Copyright:
        <a
          className="text-white hover:text-[#00002b] "
          href="https://github.com/TSjadness"
        >
          Jadson Dev
        </a>
      </div>
    </footer>
  );
}
